import { useContext } from "react";
import { WillEditorContext } from "../will-editor";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ProgressBar = ( props:any ) => {

    const { css } = useContext(WillEditorContext); 

    let bars = [];
    for ( let i = 0; i < props.views.length; i++ ) {
        const active = props.currentView < i ? '' : '';
        bars.push(
            <span key={`progress-bar-${i}`} className={ props.currentView >= i ? css.progressBar + ' ' + css['progressBar--active'] : css.progressBar }>{active}</span> 
        ); 
    }
    return(
        <>
        <div className={css.progressBars}>  
            {bars}
            { props.views.length === props.currentView+1 && <div className={css.progressBars__done}><FontAwesomeIcon icon={["fas", "check"]} /></div> }
        </div>
        </>
    )

}

export default ProgressBar;